// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   MaterielPage.css (mp-*)
   Toutes les règles sont scopées sous .mp-page
   ========================= */

.mp-page {
  --mp-brown: #6d4e36;
  --mp-brown-2: #8b5e3c;
  --mp-beige: #f5f5db;
  --mp-ok: #2e7d32;
  --mp-warn: #f9a825;
  --mp-crit: #e65100;
  --mp-danger: #b71c1c;
  --mp-muted: #8a7f74;
  --mp-line: rgba(109, 78, 54, 0.14);
  --mp-shadow: 0 4px 16px rgba(109, 78, 54, 0.08);
}

/* ── En-tête ── */
.mp-page .mp-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 24px;
  margin-bottom: 18px;
  border-radius: 16px;
  color: #fff;
  background:
    radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.12), transparent 45%),
    linear-gradient(135deg, var(--mp-brown) 0%, var(--mp-brown-2) 100%);
  box-shadow: 0 10px 28px rgba(109, 78, 54, 0.25);
}

.mp-page .mp-hero-title {
  display: flex;
  align-items: center;
  gap: 14px;
}

.mp-page .mp-hero-title h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 800;
  color: #fff;
}

.mp-page .mp-hero-icon {
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  font-size: 1.5rem;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.mp-page .mp-hero-sub {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 2px;
  font-size: 0.92rem;
  opacity: 0.92;
}

.mp-page .mp-hero-alert {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.8rem;
  color: #5d2b00;
  background: #ffd36b;
}

.mp-page .mp-hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mp-page .mp-hero-actions .btn {
  border-radius: 10px;
  font-weight: 600;
  border: none;
}

.mp-page .mp-hero-actions .btn-light {
  color: var(--mp-brown);
  background: rgba(255, 255, 255, 0.92);
}

.mp-page .mp-hero-actions .btn-light:hover {
  background: #fff;
}

.mp-page .mp-hero-actions .mp-btn-add {
  color: #3b2a1c;
  background: #ffd36b;
}

.mp-page .mp-hero-actions .mp-btn-add:hover {
  background: #ffc23a;
}

/* ── KPI état ── */
.mp-page .mp-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
}

/* ── Panneaux d'alertes ── */
.mp-page .mp-status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px;
}

.mp-page .mp-status-panel {
  padding: 14px 16px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid var(--mp-line);
  box-shadow: var(--mp-shadow);
}

.mp-page .mp-status-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.mp-page .mp-status-icon {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  color: var(--mp-brown);
  background: var(--mp-beige);
}

.mp-page .mp-status-title {
  display: flex;
  align-items: center;
  font-weight: 800;
  color: var(--mp-brown);
}

.mp-page .mp-status-total {
  margin-left: auto;
  font-size: 0.78rem;
  color: var(--mp-muted);
}

.mp-page .mp-segbar {
  display: flex;
  gap: 2px;
  height: 8px;
  margin-bottom: 12px;
  border-radius: 999px;
  overflow: hidden;
  background: #eee;
}

.mp-page .mp-segbar-empty {
  flex: 1 1;
  background: #eee;
}

.mp-page .mp-status-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.mp-page .mp-status-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.82rem;
  color: #444;
  background: #fafafa;
  border: 1px solid #e6e6e6;
  transition: all 0.15s ease;
}

.mp-page .mp-status-chip b {
  color: var(--chip);
}

.mp-page .mp-status-chip:hover {
  border-color: var(--chip);
  background: #fff;
}

.mp-page .mp-status-chip.active {
  color: #fff;
  background: var(--chip);
  border-color: var(--chip);
}

.mp-page .mp-status-chip.active b {
  color: #fff;
}

.mp-page .mp-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--chip);
}

.mp-page .mp-status-chip.active .mp-dot {
  background: #fff;
}

/* ── Barre de filtres ── */
.mp-page .mp-toolbar {
  padding: 14px 16px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid var(--mp-line);
  box-shadow: var(--mp-shadow);
}

.mp-page .mp-toolbar-row {
  display: grid;
  grid-template-columns: minmax(260px, 1.4fr) 1fr 1fr;
  gap: 10px;
}

.mp-page .mp-toolbar-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed var(--mp-line);
}

.mp-page .mp-search {
  position: relative;
}

.mp-page .mp-search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: var(--mp-muted);
  pointer-events: none;
}

.mp-page .mp-search .form-control {
  height: 38px;
  padding-left: 34px;
  border-radius: 10px;
}

.mp-page .mp-quick-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.82rem;
  color: var(--mp-brown);
  background: var(--mp-beige);
  border: 1px solid transparent;
  transition: all 0.15s ease;
}

.mp-page .mp-quick-chip b {
  margin-left: 4px;
}

.mp-page .mp-quick-chip:hover {
  border-color: var(--mp-brown-2);
}

.mp-page .mp-quick-chip.active {
  color: #fff;
  background: var(--mp-brown);
}

.mp-page .mp-active-filter {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 4px 3px 10px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--mp-brown);
  background: #fff4e0;
  border: 1px solid #f0d9b5;
}

.mp-page .mp-active-filter button {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  color: var(--mp-brown);
  background: transparent;
}

.mp-page .mp-active-filter button:hover {
  background: #f0d9b5;
}

.mp-page .mp-link-btn {
  border: none;
  background: none;
  font-size: 0.82rem;
  color: var(--mp-muted);
}

.mp-page .mp-link-btn:hover {
  color: var(--mp-brown);
  text-decoration: underline;
}

.mp-page .mp-count {
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #fff;
  background: var(--mp-brown);
}

/* ── Tableau ── */
.mp-page .mp-table-wrap {
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--mp-line);
  box-shadow: var(--mp-shadow);
}

.mp-page .mp-table-wrap .table {
  margin-bottom: 0;
}

.mp-page .mp-table-wrap .table thead th {
  padding: 12px 10px;
  font-size: 0.74rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-align: left;
  color: var(--mp-brown);
  background: var(--mp-beige) !important;
  border: none;
  border-bottom: 2px solid var(--mp-line);
  white-space: nowrap;
}

.mp-page .mp-table-wrap .table tbody td {
  padding: 10px;
  text-align: left;
  vertical-align: middle;
  background: #fff;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.mp-page .mp-table-wrap .table tbody tr:hover td {
  background: #fdfaf3;
}

/* Bande de couleur à gauche selon l'état */
.mp-page .mp-table-wrap tbody tr td:first-child {
  box-shadow: inset 4px 0 0 transparent;
}

.mp-page .mp-table-wrap tbody tr.mp-row-service td:first-child {
  box-shadow: inset 4px 0 0 var(--mp-ok);
}

.mp-page .mp-table-wrap tbody tr.mp-row-maintenance td:first-child {
  box-shadow: inset 4px 0 0 var(--mp-warn);
}

.mp-page .mp-table-wrap tbody tr.mp-row-panne td:first-child {
  box-shadow: inset 4px 0 0 var(--mp-danger);
}

.mp-page .mp-table-wrap tbody tr.mp-row-bloque td {
  opacity: 0.6;
}

.mp-page .mp-table-wrap tbody tr.mp-row-bloque td:first-child {
  box-shadow: inset 4px 0 0 #607d8b;
}

.mp-page .react-bootstrap-table-pagination {
  margin: 0;
  padding: 10px 14px;
  border-top: 1px solid var(--mp-line);
  background: #fffdf7;
}

.mp-page .mp-cell-stack {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.mp-page .mp-veh-mat {
  font-weight: 800;
  font-size: 0.95rem;
  letter-spacing: 0.02em;
  color: var(--mp-brown);
  white-space: nowrap;
}

.mp-page .mp-veh-sub {
  font-size: 0.8rem;
  color: var(--mp-muted);
}

.mp-page .mp-mode {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin-top: 2px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
}

.mp-page .mp-mode-h {
  color: #0d47a1;
  background: #e3f2fd;
}

.mp-page .mp-mode-km {
  color: #4a148c;
  background: #f3e5f5;
}

/* Barre de progression vidange */
.mp-page .mp-vidange {
  min-width: 170px;
}

.mp-page .mp-vidange-txt {
  font-size: 0.8rem;
  margin-bottom: 3px;
}

.mp-page .mp-progress {
  height: 7px;
  border-radius: 999px;
  overflow: hidden;
  background: #efe9df;
}

.mp-page .mp-progress-bar {
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease;
}

.mp-page .mp-vidange small {
  font-size: 0.72rem;
}

/* Pastilles papiers */
.mp-page .mp-papiers {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 160px;
}

.mp-page .mp-papier {
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  cursor: help;
}

.mp-page .mp-papier-ok {
  color: #1b5e20;
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
}

.mp-page .mp-papier-alerte {
  color: #6d4c00;
  background: #fff8e1;
  border: 1px solid #ffd54f;
}

.mp-page .mp-papier-depasse {
  color: #fff;
  background: var(--mp-danger);
  border: 1px solid var(--mp-danger);
}

.mp-page .mp-papier-vide {
  color: #b0a89f;
  background: transparent;
  border: 1px dashed #d6cfc6;
}

/* État */
.mp-page .mp-etat {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}

.mp-page .mp-etat::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.mp-page .mp-etat-service { color: #1b5e20; background: #e8f5e9; }
.mp-page .mp-etat-maintenance { color: #8a5300; background: #fff3e0; }
.mp-page .mp-etat-panne { color: #b71c1c; background: #ffebee; }
.mp-page .mp-etat-bloque { color: #37474f; background: #eceff1; }
.mp-page .mp-etat-autre { color: #555; background: #f2f2f2; }

/* Actions */
.mp-page .mp-actions {
  display: flex;
  gap: 4px;
}

.mp-page .mp-icon-btn {
  position: relative;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  color: var(--mp-brown);
  background: #faf7f2;
  border: 1px solid var(--mp-line);
  transition: all 0.15s ease;
}

.mp-page .mp-icon-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  color: #fff;
  background: var(--mp-brown-2);
  border-color: var(--mp-brown-2);
}

.mp-page .mp-icon-btn:disabled {
  opacity: 0.6;
}

.mp-page .mp-icon-btn-primary:hover:not(:disabled) {
  background: #1565c0;
  border-color: #1565c0;
}

.mp-page .mp-icon-btn-danger:hover:not(:disabled) {
  background: #c62828;
  border-color: #c62828;
}

.mp-page .mp-icon-count {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 800;
  line-height: 17px;
  color: #fff;
  background: #00897b;
}

/* États vides / chargement */
.mp-page .mp-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 50px;
  color: var(--mp-muted);
}

.mp-page .mp-empty {
  padding: 40px 10px;
  text-align: center;
  color: var(--mp-muted);
}

.mp-page .mp-empty svg {
  font-size: 2.2rem;
  opacity: 0.35;
  margin-bottom: 8px;
}

/* ── Modal (SimpleModal) ── */
.mp-modal-backdrop {
  backdrop-filter: blur(3px);
}

.mp-modal {
  animation: mp-pop 0.14s ease-out;
}

@keyframes mp-pop {
  from {
    transform: translateY(6px) scale(0.99);
    opacity: 0.6;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.mp-modal-header {
  color: #6d4e36;
  background: #f5f5db;
}

.mp-modal-body {
  background: #fcfbf7;
}

.mp-modal-body label {
  margin-bottom: 3px;
  font-size: 0.8rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.6);
}

.mp-form-section {
  height: auto;
  margin-bottom: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid rgba(109, 78, 54, 0.14);
}

.mp-form-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  font-weight: 800;
  color: #6d4e36;
  border-bottom: 1px solid rgba(109, 78, 54, 0.1);
}

/* react-select inside modal */
.react-select__menu {
  z-index: 10000 !important;
}

/* ── Responsive ── */
@media (max-width: 991px) {
  .mp-page .mp-toolbar-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .mp-page .mp-hero {
    padding: 16px;
  }

  .mp-page .mp-hero-title h2 {
    font-size: 1.3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MaterielPage.css"],"names":[],"mappings":"AAAA;;;8BAG8B;;AAE9B;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX;;uEAEqE;EACrE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,4BAA4B,cAAc,EAAE,mBAAmB,EAAE;AACjE,gCAAgC,cAAc,EAAE,mBAAmB,EAAE;AACrE,0BAA0B,cAAc,EAAE,mBAAmB,EAAE;AAC/D,2BAA2B,cAAc,EAAE,mBAAmB,EAAE;AAChE,0BAA0B,WAAW,EAAE,mBAAmB,EAAE;;AAE5D,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,sCAAsC;IACtC,YAAY;EACd;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* =========================\r\n   MaterielPage.css (mp-*)\r\n   Toutes les règles sont scopées sous .mp-page\r\n   ========================= */\r\n\r\n.mp-page {\r\n  --mp-brown: #6d4e36;\r\n  --mp-brown-2: #8b5e3c;\r\n  --mp-beige: #f5f5db;\r\n  --mp-ok: #2e7d32;\r\n  --mp-warn: #f9a825;\r\n  --mp-crit: #e65100;\r\n  --mp-danger: #b71c1c;\r\n  --mp-muted: #8a7f74;\r\n  --mp-line: rgba(109, 78, 54, 0.14);\r\n  --mp-shadow: 0 4px 16px rgba(109, 78, 54, 0.08);\r\n}\r\n\r\n/* ── En-tête ── */\r\n.mp-page .mp-hero {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  padding: 20px 24px;\r\n  margin-bottom: 18px;\r\n  border-radius: 16px;\r\n  color: #fff;\r\n  background:\r\n    radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.12), transparent 45%),\r\n    linear-gradient(135deg, var(--mp-brown) 0%, var(--mp-brown-2) 100%);\r\n  box-shadow: 0 10px 28px rgba(109, 78, 54, 0.25);\r\n}\r\n\r\n.mp-page .mp-hero-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n}\r\n\r\n.mp-page .mp-hero-title h2 {\r\n  margin: 0;\r\n  font-size: 1.6rem;\r\n  font-weight: 800;\r\n  color: #fff;\r\n}\r\n\r\n.mp-page .mp-hero-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 52px;\r\n  height: 52px;\r\n  border-radius: 14px;\r\n  font-size: 1.5rem;\r\n  background: rgba(255, 255, 255, 0.16);\r\n  border: 1px solid rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n.mp-page .mp-hero-sub {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-top: 2px;\r\n  font-size: 0.92rem;\r\n  opacity: 0.92;\r\n}\r\n\r\n.mp-page .mp-hero-alert {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 10px;\r\n  border-radius: 999px;\r\n  font-weight: 700;\r\n  font-size: 0.8rem;\r\n  color: #5d2b00;\r\n  background: #ffd36b;\r\n}\r\n\r\n.mp-page .mp-hero-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.mp-page .mp-hero-actions .btn {\r\n  border-radius: 10px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.mp-page .mp-hero-actions .btn-light {\r\n  color: var(--mp-brown);\r\n  background: rgba(255, 255, 255, 0.92);\r\n}\r\n\r\n.mp-page .mp-hero-actions .btn-light:hover {\r\n  background: #fff;\r\n}\r\n\r\n.mp-page .mp-hero-actions .mp-btn-add {\r\n  color: #3b2a1c;\r\n  background: #ffd36b;\r\n}\r\n\r\n.mp-page .mp-hero-actions .mp-btn-add:hover {\r\n  background: #ffc23a;\r\n}\r\n\r\n/* ── KPI état ── */\r\n.mp-page .mp-kpi-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n/* ── Panneaux d'alertes ── */\r\n.mp-page .mp-status-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.mp-page .mp-status-panel {\r\n  padding: 14px 16px;\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  border: 1px solid var(--mp-line);\r\n  box-shadow: var(--mp-shadow);\r\n}\r\n\r\n.mp-page .mp-status-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mp-page .mp-status-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 9px;\r\n  color: var(--mp-brown);\r\n  background: var(--mp-beige);\r\n}\r\n\r\n.mp-page .mp-status-title {\r\n  display: flex;\r\n  align-items: center;\r\n  font-weight: 800;\r\n  color: var(--mp-brown);\r\n}\r\n\r\n.mp-page .mp-status-total {\r\n  margin-left: auto;\r\n  font-size: 0.78rem;\r\n  color: var(--mp-muted);\r\n}\r\n\r\n.mp-page .mp-segbar {\r\n  display: flex;\r\n  gap: 2px;\r\n  height: 8px;\r\n  margin-bottom: 12px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  background: #eee;\r\n}\r\n\r\n.mp-page .mp-segbar-empty {\r\n  flex: 1;\r\n  background: #eee;\r\n}\r\n\r\n.mp-page .mp-status-items {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n}\r\n\r\n.mp-page .mp-status-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  font-size: 0.82rem;\r\n  color: #444;\r\n  background: #fafafa;\r\n  border: 1px solid #e6e6e6;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.mp-page .mp-status-chip b {\r\n  color: var(--chip);\r\n}\r\n\r\n.mp-page .mp-status-chip:hover {\r\n  border-color: var(--chip);\r\n  background: #fff;\r\n}\r\n\r\n.mp-page .mp-status-chip.active {\r\n  color: #fff;\r\n  background: var(--chip);\r\n  border-color: var(--chip);\r\n}\r\n\r\n.mp-page .mp-status-chip.active b {\r\n  color: #fff;\r\n}\r\n\r\n.mp-page .mp-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: var(--chip);\r\n}\r\n\r\n.mp-page .mp-status-chip.active .mp-dot {\r\n  background: #fff;\r\n}\r\n\r\n/* ── Barre de filtres ── */\r\n.mp-page .mp-toolbar {\r\n  padding: 14px 16px;\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  border: 1px solid var(--mp-line);\r\n  box-shadow: var(--mp-shadow);\r\n}\r\n\r\n.mp-page .mp-toolbar-row {\r\n  display: grid;\r\n  grid-template-columns: minmax(260px, 1.4fr) 1fr 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.mp-page .mp-toolbar-foot {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-top: 12px;\r\n  padding-top: 12px;\r\n  border-top: 1px dashed var(--mp-line);\r\n}\r\n\r\n.mp-page .mp-search {\r\n  position: relative;\r\n}\r\n\r\n.mp-page .mp-search-icon {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 12px;\r\n  transform: translateY(-50%);\r\n  color: var(--mp-muted);\r\n  pointer-events: none;\r\n}\r\n\r\n.mp-page .mp-search .form-control {\r\n  height: 38px;\r\n  padding-left: 34px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.mp-page .mp-quick-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 4px 12px;\r\n  border-radius: 999px;\r\n  font-size: 0.82rem;\r\n  color: var(--mp-brown);\r\n  background: var(--mp-beige);\r\n  border: 1px solid transparent;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.mp-page .mp-quick-chip b {\r\n  margin-left: 4px;\r\n}\r\n\r\n.mp-page .mp-quick-chip:hover {\r\n  border-color: var(--mp-brown-2);\r\n}\r\n\r\n.mp-page .mp-quick-chip.active {\r\n  color: #fff;\r\n  background: var(--mp-brown);\r\n}\r\n\r\n.mp-page .mp-active-filter {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 3px 4px 3px 10px;\r\n  border-radius: 999px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: var(--mp-brown);\r\n  background: #fff4e0;\r\n  border: 1px solid #f0d9b5;\r\n}\r\n\r\n.mp-page .mp-active-filter button {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  color: var(--mp-brown);\r\n  background: transparent;\r\n}\r\n\r\n.mp-page .mp-active-filter button:hover {\r\n  background: #f0d9b5;\r\n}\r\n\r\n.mp-page .mp-link-btn {\r\n  border: none;\r\n  background: none;\r\n  font-size: 0.82rem;\r\n  color: var(--mp-muted);\r\n}\r\n\r\n.mp-page .mp-link-btn:hover {\r\n  color: var(--mp-brown);\r\n  text-decoration: underline;\r\n}\r\n\r\n.mp-page .mp-count {\r\n  padding: 3px 12px;\r\n  border-radius: 999px;\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  background: var(--mp-brown);\r\n}\r\n\r\n/* ── Tableau ── */\r\n.mp-page .mp-table-wrap {\r\n  border-radius: 14px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  border: 1px solid var(--mp-line);\r\n  box-shadow: var(--mp-shadow);\r\n}\r\n\r\n.mp-page .mp-table-wrap .table {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mp-page .mp-table-wrap .table thead th {\r\n  padding: 12px 10px;\r\n  font-size: 0.74rem;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  text-align: left;\r\n  color: var(--mp-brown);\r\n  background: var(--mp-beige) !important;\r\n  border: none;\r\n  border-bottom: 2px solid var(--mp-line);\r\n  white-space: nowrap;\r\n}\r\n\r\n.mp-page .mp-table-wrap .table tbody td {\r\n  padding: 10px;\r\n  text-align: left;\r\n  vertical-align: middle;\r\n  background: #fff;\r\n  border: none;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.mp-page .mp-table-wrap .table tbody tr:hover td {\r\n  background: #fdfaf3;\r\n}\r\n\r\n/* Bande de couleur à gauche selon l'état */\r\n.mp-page .mp-table-wrap tbody tr td:first-child {\r\n  box-shadow: inset 4px 0 0 transparent;\r\n}\r\n\r\n.mp-page .mp-table-wrap tbody tr.mp-row-service td:first-child {\r\n  box-shadow: inset 4px 0 0 var(--mp-ok);\r\n}\r\n\r\n.mp-page .mp-table-wrap tbody tr.mp-row-maintenance td:first-child {\r\n  box-shadow: inset 4px 0 0 var(--mp-warn);\r\n}\r\n\r\n.mp-page .mp-table-wrap tbody tr.mp-row-panne td:first-child {\r\n  box-shadow: inset 4px 0 0 var(--mp-danger);\r\n}\r\n\r\n.mp-page .mp-table-wrap tbody tr.mp-row-bloque td {\r\n  opacity: 0.6;\r\n}\r\n\r\n.mp-page .mp-table-wrap tbody tr.mp-row-bloque td:first-child {\r\n  box-shadow: inset 4px 0 0 #607d8b;\r\n}\r\n\r\n.mp-page .react-bootstrap-table-pagination {\r\n  margin: 0;\r\n  padding: 10px 14px;\r\n  border-top: 1px solid var(--mp-line);\r\n  background: #fffdf7;\r\n}\r\n\r\n.mp-page .mp-cell-stack {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: 1.25;\r\n}\r\n\r\n.mp-page .mp-veh-mat {\r\n  font-weight: 800;\r\n  font-size: 0.95rem;\r\n  letter-spacing: 0.02em;\r\n  color: var(--mp-brown);\r\n  white-space: nowrap;\r\n}\r\n\r\n.mp-page .mp-veh-sub {\r\n  font-size: 0.8rem;\r\n  color: var(--mp-muted);\r\n}\r\n\r\n.mp-page .mp-mode {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  width: fit-content;\r\n  margin-top: 2px;\r\n  padding: 0 8px;\r\n  border-radius: 999px;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.mp-page .mp-mode-h {\r\n  color: #0d47a1;\r\n  background: #e3f2fd;\r\n}\r\n\r\n.mp-page .mp-mode-km {\r\n  color: #4a148c;\r\n  background: #f3e5f5;\r\n}\r\n\r\n/* Barre de progression vidange */\r\n.mp-page .mp-vidange {\r\n  min-width: 170px;\r\n}\r\n\r\n.mp-page .mp-vidange-txt {\r\n  font-size: 0.8rem;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.mp-page .mp-progress {\r\n  height: 7px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  background: #efe9df;\r\n}\r\n\r\n.mp-page .mp-progress-bar {\r\n  height: 100%;\r\n  border-radius: 999px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.mp-page .mp-vidange small {\r\n  font-size: 0.72rem;\r\n}\r\n\r\n/* Pastilles papiers */\r\n.mp-page .mp-papiers {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  min-width: 160px;\r\n}\r\n\r\n.mp-page .mp-papier {\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  font-size: 0.68rem;\r\n  font-weight: 800;\r\n  letter-spacing: 0.03em;\r\n  cursor: help;\r\n}\r\n\r\n.mp-page .mp-papier-ok {\r\n  color: #1b5e20;\r\n  background: #e8f5e9;\r\n  border: 1px solid #a5d6a7;\r\n}\r\n\r\n.mp-page .mp-papier-alerte {\r\n  color: #6d4c00;\r\n  background: #fff8e1;\r\n  border: 1px solid #ffd54f;\r\n}\r\n\r\n.mp-page .mp-papier-depasse {\r\n  color: #fff;\r\n  background: var(--mp-danger);\r\n  border: 1px solid var(--mp-danger);\r\n}\r\n\r\n.mp-page .mp-papier-vide {\r\n  color: #b0a89f;\r\n  background: transparent;\r\n  border: 1px dashed #d6cfc6;\r\n}\r\n\r\n/* État */\r\n.mp-page .mp-etat {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 3px 10px;\r\n  border-radius: 999px;\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mp-page .mp-etat::before {\r\n  content: '';\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n}\r\n\r\n.mp-page .mp-etat-service { color: #1b5e20; background: #e8f5e9; }\r\n.mp-page .mp-etat-maintenance { color: #8a5300; background: #fff3e0; }\r\n.mp-page .mp-etat-panne { color: #b71c1c; background: #ffebee; }\r\n.mp-page .mp-etat-bloque { color: #37474f; background: #eceff1; }\r\n.mp-page .mp-etat-autre { color: #555; background: #f2f2f2; }\r\n\r\n/* Actions */\r\n.mp-page .mp-actions {\r\n  display: flex;\r\n  gap: 4px;\r\n}\r\n\r\n.mp-page .mp-icon-btn {\r\n  position: relative;\r\n  display: grid;\r\n  place-items: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 9px;\r\n  color: var(--mp-brown);\r\n  background: #faf7f2;\r\n  border: 1px solid var(--mp-line);\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.mp-page .mp-icon-btn:hover:not(:disabled) {\r\n  transform: translateY(-1px);\r\n  color: #fff;\r\n  background: var(--mp-brown-2);\r\n  border-color: var(--mp-brown-2);\r\n}\r\n\r\n.mp-page .mp-icon-btn:disabled {\r\n  opacity: 0.6;\r\n}\r\n\r\n.mp-page .mp-icon-btn-primary:hover:not(:disabled) {\r\n  background: #1565c0;\r\n  border-color: #1565c0;\r\n}\r\n\r\n.mp-page .mp-icon-btn-danger:hover:not(:disabled) {\r\n  background: #c62828;\r\n  border-color: #c62828;\r\n}\r\n\r\n.mp-page .mp-icon-count {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: -6px;\r\n  min-width: 17px;\r\n  height: 17px;\r\n  padding: 0 4px;\r\n  border-radius: 999px;\r\n  font-size: 0.65rem;\r\n  font-weight: 800;\r\n  line-height: 17px;\r\n  color: #fff;\r\n  background: #00897b;\r\n}\r\n\r\n/* États vides / chargement */\r\n.mp-page .mp-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 50px;\r\n  color: var(--mp-muted);\r\n}\r\n\r\n.mp-page .mp-empty {\r\n  padding: 40px 10px;\r\n  text-align: center;\r\n  color: var(--mp-muted);\r\n}\r\n\r\n.mp-page .mp-empty svg {\r\n  font-size: 2.2rem;\r\n  opacity: 0.35;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n/* ── Modal (SimpleModal) ── */\r\n.mp-modal-backdrop {\r\n  backdrop-filter: blur(3px);\r\n}\r\n\r\n.mp-modal {\r\n  animation: mp-pop 0.14s ease-out;\r\n}\r\n\r\n@keyframes mp-pop {\r\n  from {\r\n    transform: translateY(6px) scale(0.99);\r\n    opacity: 0.6;\r\n  }\r\n  to {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.mp-modal-header {\r\n  color: #6d4e36;\r\n  background: #f5f5db;\r\n}\r\n\r\n.mp-modal-body {\r\n  background: #fcfbf7;\r\n}\r\n\r\n.mp-modal-body label {\r\n  margin-bottom: 3px;\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.mp-form-section {\r\n  height: auto;\r\n  margin-bottom: 12px;\r\n  padding: 14px 16px;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  border: 1px solid rgba(109, 78, 54, 0.14);\r\n}\r\n\r\n.mp-form-section-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 8px;\r\n  font-weight: 800;\r\n  color: #6d4e36;\r\n  border-bottom: 1px solid rgba(109, 78, 54, 0.1);\r\n}\r\n\r\n/* react-select inside modal */\r\n.react-select__menu {\r\n  z-index: 10000 !important;\r\n}\r\n\r\n/* ── Responsive ── */\r\n@media (max-width: 991px) {\r\n  .mp-page .mp-toolbar-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .mp-page .mp-hero {\r\n    padding: 16px;\r\n  }\r\n\r\n  .mp-page .mp-hero-title h2 {\r\n    font-size: 1.3rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
